import { render, staticRenderFns } from "./R-score-traffic-light-widget.vue?vue&type=template&id=8e88bd1c"
import script from "./R-score-traffic-light-widget.vue?vue&type=script&lang=js"
export * from "./R-score-traffic-light-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports